import React, { Component } from "react";
import ReactFullpage from "@fullpage/react-fullpage";
import {
  Container,
  Header,
  Image,
  Icon,
  Button,
  Grid,
  Divider,
  Label,
  Modal,
  TransitionablePortal,
} from "semantic-ui-react";
import { Swiper, SwiperSlide } from "swiper/react";
import { EffectCoverflow, Navigation, Pagination } from "swiper/modules";
import HeaderInfo from "../../components/shared/header";
import Sidebar from "../../components/shared/sidebar";
import { fetchJsonData } from "../../helpers/fetchJsonData";
import "./projects.css";

class Projects extends Component {
  constructor(props) {
    super(props);
    this.state = { menuOpen: false, data: [], open: false };
  }

  async componentDidMount() {
    const jsonData = await fetchJsonData("/static/data/projects.json");
    this.setState({ data: jsonData });
  }

  handleStateChange = (state) => this.setState({ menuOpen: state.isOpen });
  toggleMenu = () =>
    this.setState((prevState) => ({ menuOpen: !prevState.menuOpen }));
  openModal = () => this.setState({ open: true });
  closeModal = () => this.setState({ open: false });

  render() {
    const { data, menuOpen, open } = this.state;

    return (
      <div id="App">
        <Sidebar
          pageWrapId="full-screen"
          outerContainerId="App"
          isOpen={menuOpen}
          onStateChange={this.handleStateChange}
          active="projects"
        />
        <main id="full-screen">
          <div className="light-nav">
            <Container>
              <div className="header-content">
                <HeaderInfo />
                <Button inverted icon size="big" onClick={this.toggleMenu}>
                  <Icon name="bars" />
                </Button>
              </div>
            </Container>
          </div>
          <div className="projects-page">
            <ReactFullpage
              navigation
              render={() => (
                <ReactFullpage.Wrapper>
                  <div className="section" data-anchor="main">
                    <div className="content">
                      <Header as="h1" className="welcome-projects">
                        <Header.Content>Projects</Header.Content>
                      </Header>
                      <Icon
                        inverted
                        name="chevron down"
                        className="go-down bounce"
                      />
                    </div>
                    <div className="gradient MidnightCity"></div>
                    <div className="lowpoly"></div>
                  </div>
                  {data.map((project, index) => (
                    <div
                      key={index}
                      className="section"
                      style={{
                        background: `rgba(201, 124, 124, 0) url(${project.thumb}) repeat scroll 0% 0%`,
                      }}
                      data-fp-styles={{
                        background: `rgba(0, 0, 0, 0) url(${project.thumb}) repeat scroll 0% 0%`,
                      }}
                      data-anchor={project.slug}
                    >
                      <div className="content">
                        <Grid>
                          <Grid.Row>
                            <Grid.Column className="center">
                              <Header as="h2" icon>
                                <Image src={project.logo} centered />
                                <Divider hidden />
                                {project.name}
                                <Header.Subheader>
                                  {project.desc}
                                </Header.Subheader>
                              </Header>
                            </Grid.Column>
                          </Grid.Row>
                          <Grid.Row className="center languages">
                            {project.role && (
                              <Label color="red">{project.role}</Label>
                            )}
                            {project.languages?.sort().map((lang, j) => (
                              <Label key={j}>{lang}</Label>
                            ))}
                          </Grid.Row>
                          <Grid.Row className="center btns">
                            <div className="platforms">
                              {project.platforms?.map((platform, j) => (
                                <a
                                  key={j}
                                  href={platform.link}
                                  target="_blank"
                                  rel="noopener noreferrer"
                                >
                                  <Button
                                    circular
                                    basic
                                    inverted
                                    icon={platform.type}
                                  />
                                </a>
                              ))}
                            </div>
                            <Button circular inverted onClick={this.openModal}>
                              {project.view_title}
                            </Button>
                            <TransitionablePortal
                              open={open}
                              onOpen={() =>
                                setTimeout(
                                  () =>
                                    document.body.classList.add(
                                      "modal-fade-in"
                                    ),
                                  0
                                )
                              }
                              transition={{ animation: "scale", duration: 500 }}
                            >
                              <Modal
                                className="preview-lightbox"
                                open={true}
                                onClose={(_) => {
                                  document.body.classList.remove(
                                    "modal-fade-in"
                                  );
                                  this.closeModal();
                                }}
                                closeIcon
                              >
                                <Modal.Content>
                                  <Swiper
                                    effect={"coverflow"}
                                    grabCursor={true}
                                    centeredSlides={true}
                                    slidesPerView={"auto"}
                                    coverflowEffect={{
                                      rotate: 50,
                                      stretch: 0,
                                      depth: 100,
                                      modifier: 1,
                                      slideShadows: true,
                                    }}
                                    navigation={true}
                                    pagination={true}
                                    modules={[
                                      EffectCoverflow,
                                      Pagination,
                                      Navigation,
                                    ]}
                                  >
                                    {project.preview?.map((media, j) => (
                                      <SwiperSlide key={j}>
                                        <img alt={media.img} src={media.img} />
                                      </SwiperSlide>
                                    ))}
                                  </Swiper>
                                </Modal.Content>
                              </Modal>
                            </TransitionablePortal>
                          </Grid.Row>
                          {project.credit && (
                            <Grid.Row className="center credit">
                              <Divider inverted hidden />
                              <div
                                dangerouslySetInnerHTML={{
                                  __html: project.credit,
                                }}
                              />
                            </Grid.Row>
                          )}
                        </Grid>
                      </div>
                      <div className={`gradient ${project.gradient}`}></div>
                    </div>
                  ))}
                </ReactFullpage.Wrapper>
              )}
            />
          </div>
        </main>
      </div>
    );
  }
}

export default Projects;
